import React from 'react'
import upstriveLogo from '../../upstrive_education_logo.png'
import '../../styles/UnauthenticatedApp.css'
import LoginImage from '../../svg/LoginImage'
import { ReactComponent as AlkalmaLogo } from '../../AlkalmaLogoWhiteOnBlue.svg'

function LoginWrapper({ children }) {
    return (
        <div className="app-container">
            <div className="action-section">
                <div className="login-container">
                    {/* <div className="upstrive-login-image-container">
                        <LoginImage />
                    </div> */}
                    <div className="upstrive-login-container">
                        <div className="login-image-container">
                            <div>
                                <AlkalmaLogo className="login-image" height={143} />
                            </div>
                        </div>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LoginWrapper
